import React from 'react'
import { List } from 'semantic-ui-react';

import { Plant } from '../../../../src/types';

const SettingsList = ({ plant }: { plant: Plant }) => {
    return (
        <List horizontal>
            <List.Item>
                <List.Header>
                    dry value
                </List.Header>
                <List.Description>
                    {plant.dryValue}
                </List.Description>
            </List.Item>
            <List.Item>
                <List.Header>
                    wet value
                </List.Header>
                <List.Description>
                    {plant.wetValue}
                </List.Description>
            </List.Item>
            <List.Item>
                <List.Header>
                    valve
                </List.Header>
                <List.Description>
                    {plant.valve}
                </List.Description>
            </List.Item>
            <List.Item>
                <List.Header>
                    channel
                </List.Header>
                <List.Description>
                    {plant.channel}
                </List.Description>
            </List.Item>
            <List.Item>
                <List.Header>
                    minimum tolerance
                </List.Header>
                <List.Description>
                    {`${plant.minimumTolerance}%`}
                </List.Description>
            </List.Item>
            <List.Item>
                <List.Header>
                    set point
                </List.Header>
                <List.Description>
                    {`${plant.setPoint}%`}
                </List.Description>
            </List.Item>
            <List.Item>
                <List.Header>
                    pump time
                </List.Header>
                <List.Description>
                    {`${plant.pumpTime} seconds`}
                </List.Description>
            </List.Item>
            <List.Item>
                <List.Header>
                    volume watered
                </List.Header>
                <List.Description>
                    {`${plant.volume_watered?.toFixed(3)} L`}
                </List.Description>
            </List.Item>
            <List.Item>
                <List.Header>
                    water volume threshold
                </List.Header>
                <List.Description>
                    {`${plant.water_volume_threshold?.toFixed(3)} L`}
                </List.Description>
            </List.Item>
        </List>
    )
};

export default SettingsList;